import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triangle-down",
  "use": "icon-triangle-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-triangle-down\"><defs><style type=\"text/css\"></style></defs><path d=\"M511.8342991 760.55134815l496.7712945-496.7712945L15.06300461 263.78005365 511.8342991 760.55134815z\" fill=\"#666666\" p-id=\"1013\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol